import { platform } from 'os'
import axios from './axios'
import { response } from 'express'

interface UpdateForKycData {
  birthDate: string
  street: string
  zipCode: string
  gender:string
  city: string
  countryOfBirthCode: string
  countryOfBirthName: string
  occupation: string
  transactionPerMonth: string
  numberTransactionsPerMonth: string
}
// SIGNUP AUTH
export const Signup = (signupObject: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    
    if (signupObject) {
      const body = {
        platform: 'web',
        firstName: signupObject.nom,
        lastName: signupObject.prenom,
        // gender: signupObject.valueGender,
        phoneNumber: signupObject.telephone,
        phonePrefix: signupObject.prefix,
        country: signupObject.contryCode,
        countryCode: signupObject.valuePaysSelect,
        email: signupObject.email,
        password: signupObject.password,
        referralCode: '',
        language: 'fra'
      }

      axios
        .post('/users/signup', body)
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    } else {
      reject(new Error('signupObject est manquant ou invalide'))
    }
  })
}


//validation SMS
export const VerifySMSCode = ( userId: string, code: string)=>
  new Promise((resolve, reject) => {
    if (userId && code) {
      axios .post('users/verify-sms-code', {userId, code})
      .then((response)=>{
        resolve(response.data)
      })
      .catch((error)=>{
        reject(error)
      })
}
  })

  //ResendSMS
  export const ResendSMSCode = async( userId: string)=>{
  try{
      
    await axios .post('users/resend-sms-code', {userId})
      
     } catch(error){
        console.error(error)
      }
}
  

// API FOR KYC 

export const UpdateForKyc = (
    id: string | undefined,
    token: string | undefined,
    updateForKycObject: UpdateForKycData) => {

    const body = {
      userId: id,
      birthDate: new Date(`${updateForKycObject.birthDate}T00:00:00`).toISOString(),
      street: updateForKycObject.street,
      zipCode: updateForKycObject.zipCode,
      gender: updateForKycObject.gender,
      city: updateForKycObject.city, 
      countryOfBirthCode: updateForKycObject.countryOfBirthCode,
      countryOfBirthName: updateForKycObject.countryOfBirthName,
      occupation: updateForKycObject.occupation,
      transactionPerMonth: Number(updateForKycObject.transactionPerMonth),
      numberTransactionsPerMonth: Number(updateForKycObject.numberTransactionsPerMonth),
      platform : 'web'
    }
    const response = axios.post(`/users/updateForKyc`,  body, {
      headers: {
        "authorization": token,
        "Content-Type": 'application/json',
      },
    })
   
 return response
}
  

export const activateAccount = (token: any) => {
  return new Promise((resolve, reject) => {
    const body = {
      token: token,
      platform: 'web',
    }
    axios.post('/auth/activation', body)
      .then((response) => {
        resolve(response.data)

      })
      .catch((err) => {
        reject(err)
      })
  })
}
 


// API AUTH
export const Login = ({ email, password }: any) =>
  new Promise((resolve, reject) => {
    if (email && password) {
      axios
        .post('/auth/user', { email, password, platform: 'web' })
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    }
  })

// API CALCULATE

export const getCurrencies = () =>
  axios
    .get(`/currencies`)
    .then((response) => {
      if (response?.data?.currencies) {
        return response?.data?.currencies
      }
    })
    .catch((error) => {
      console.log(error)
    })

export const getCurrenciesWithServices = () =>
  axios
    .get(`/currencies/destinations_currencies`)
    .then((response) => {
      if (response?.data?.currencies) {
        return response?.data?.currencies
      }
    })
    .catch((error) => {
      console.log(error)
    })

export const getFxRate = (
  departureCurrencyId: string,
  destinationCurrencyId: string,
) =>
  axios
    .get(
      `/fxrates/fxrate?departureCurrencyId=${departureCurrencyId}&destinationCurrencyId=${destinationCurrencyId}`,
    )
    .then((response) => {
      if (response?.data?.fxRate) {
        return response?.data?.fxRate
      }
    })
    .catch((error) => {
      console.log(error)
    })

export const commission = (currencyId: string, amountToSend: string) =>
  axios
    .get(
      `/commissions/commission?currencyId=${currencyId}&amountToSend=${amountToSend}`,
    )
    .then((response) => {
      if (response?.data?.commission) {
        return response?.data?.commission
      }
    })
    .catch((error) => {
      console.log(error)
    })


// Beneficiares
interface AddBeneficiaryResponse {
  success: boolean
  data: any
  msg: string
}
export const AddBeneficiary = async (
  id: string | undefined,
  token: string |undefined,
  data: any
): Promise<AddBeneficiaryResponse> => {
  const response = await axios.post(
    `/beneficiaries/${id}`,
    data,
    {
      headers: {
        authorization: token,
        'Content-Type': 'application/json',
      },
    }
  )

  return response.data
}

// export const AddBeneficiary = (id:string | undefined, token: string | undefined, data:any) => {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(`/beneficiaries/${id}`,  data, {headers:{
//           "authorization": token,
//           "Content-Type": 'application/json',
//         }}
//       )
//       .then(response => {
//         resolve(response.data)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }